// Animate It V5.3.1
// used for wiggling elements, mouse and scroll with interaction
// also copy _animate-it.scss

// init: animateIt = new AnimateIt(); animateIt.init();

// possible properties:
// frameFunction = '': external frame animation function using this frame handler

// SMOOTH SCROLL ---------------------------------------------------------------
// adds smoothscroll with sticky support, supports 1 instance

// smoothScroll usage: animateIt.smoothScroll({});

// required properties:
// none

// possible properties:
// speed = 0.1: larger is faster
// bounce = 0.01: larger is less overschoot
// iframeScrollDelay = 1000: delay before iframe can take over native scrolling
// useHorizontalWheel = false: does horizontal wheel input also scroll vertically?
// startScroll = -1: use this starting scroll position instead of current browser scroll
// scrollToAnchor = true: allow clicking hash links to scroll to matching elements

// related methods:
// animateIt.setScrollPosHard({ pos: 0 }); immediately here, even if smooth is on
// animateIt.setScrollPosSoft({ pos: 0 }); use smoothscroll here
// animateIt.disableSmoothScroll(); disables smoothscroll
// animateIt.enableSmoothScroll(); enables smoothscroll
// animateIt.removeSmoothScroll(); removes smoothscroll altogether
// animateIt.leaveIframe(); same as when mouse leaves iframe
// animateIt.resizeHandler(true); force recalculate sizes/positions

// WIGGLE ----------------------------------------------------------------------
// makes elements wiggle, can create multiple instances

// wiggle usage: animateIt.wiggle({ selector: '#selector' });

// required properties:
// selector: element selector

// possible properties:
// speed = 0.1: larger is faster
// bounce = 0.01: larger is less overschoot
// distance = 20: max position switch distance in px
// switchPerSec = 2: number of position switches per second
// slowScroll = false: does it scroll along slowly?
// mousePush = false: does it move with the mouse?
// mousePushRate = 1: how much does it move with the mouse, larger = more
// scrollPush = false: does it move with the scroll?
// scrollPushRate = 1: how much does it move with the scroll, larger = more
// wiggle = true: does it wiggle?

// related methods:
// animateIt.destroyWiggler(wiggler, removeElement = false); remove a wiggler instance

// FOLLOW MOUSE  ---------------------------------------------------------------
// makes an element follow the mouse, supports 1 instance

// followMouse usage: animateIt.followMouse({ selector: '#selector' });

// required properties:
// selector: element selector

// possible properties:
// speed = 1: larger is faster
// bounce = 0.1: larger is less overschoot
// rotate = false: does the element rotate?
// scrollSmear = false: is the mouse animated by scrolling?

// issues: ---------------------------------------------------------------------
// smoothscroll on iframe is not working on firefox

// changelog:
// 3.0 added slowscroll
// 3.0.1 cleaner scripts and fixed ResizeObserver
// 3.1 added setting smooth scroll position (because it interferes with scrollTop)
// 3.1.2 eslint
// 3.2 fix firefox iframe scroll bug
// 3.3 add disable smooth scroll function
// 3.3.1 fix intertia hickup on touch devices
// 3.3.2 make arrays available to external functions
// 3.3.3 fix ios scroll bug
// 3.3.4 removed scrollbar on smooth scroll
// 3.3.5 nicer wait on new frame
// 3.4 add keyboard control for smooth scroll
// 3.4.1 fix scroll on iframe
// 3.4.2 block resize observer option
// 3.4.3 fix for leaving iframe without mouseout (for instance on page switch)
// 3.4.4 add focus handler, for scrolling to focus
// 3.4.5 fix focus handler: only work with keyboard focus
// 3.4.6 fix for enabling scroll when body was fixed
// 3.4.7 make scrollDiff available outside
// 3.4.8 add mousy hover for select elements
// 3.4.9 don't set scroll when not moving to save performance
// 3.4.10 do keyboard focus action only once
// 3.4.11 make scroller available outside, fix hash links on current page
// 3.4.12 fix inertia on touch devices
// 3.4.13 make scrollDiff available without smoothscroll
// 3.4.14 fix for enabling wheel when blocking smoothscroll
// 3.4.15 don't start mouse in center (often in the way)
// 3.4.16 fix for undefined href
// 3.4.17 add preventSearch option
// 3.4.18 fix search instead of preventSearch
// 4.0 remove jquery dependency
// 4.0.1 fix for non smoothscroll
// 4.1 new drag css
// 4.1.1 offsetTop fix
// 4.2 fix events
// 4.2.1 fix for scrolling when in form element
// 4.2.2 fix smooth scroll to keyboard focus
// 4.2.3 turn of smoothscroll when using pen/stylus on non touchscreen
// 4.3 cleanup of getAttribute code, add removeSmoothScroll
// 4.3.1 cleanup of keycode
// 4.4 hide scrollbar on smoothscroll when document is not in focus
// 4.4.1 only enable smoothscroll after window blur if it was enabled before
// 4.5 return objects to calling functions, add non wiggle option, add destroy wiggler option
// 4.5.1 fix blocked scroll after click on iframe
// 4.6 add difference vars for wigglers
// 4.6.1 only scroll to keyboard focus if not in view
// 4.7 add scrollbar
// 4.7.1 fix scrollbar height
// 4.7.2 add el from event function
// 4.7.3 add aria label to scrollbar
// 4.7.4 add check for scrollbar
// 4.7.5 don't always add fader--still, subpixel for firefox partly
// 4.7.6 fix slowscroll wiggle flash in view on resize
// 4.7.7 don't use scss vars
// 4.7.8 fix smoothscroll start if no history js
// 4.7.9 fix preventDefault error
// 4.8 add scrollPush option
// 4.8.1 fix unblock smoothscroll
// 4.8.2 fix swiper hovers
// 4.8.3 fix anchor links
// 4.8.4 add click pulse
// 4.9 fix for non existing element, allow element instead of selector
// 4.9.1 replace elFromEvent function with inline event.target.closest calls
// 4.10 call resize after unblocking resize observer
// 4.11 add more support for keyboard scrolling
// 4.12 make resizeHandler publicly available, remove resize call on unblock
// 4.13 add useHorizontalWheel option for smoothscroll wheel input
// 4.14 add startScroll option for smoothScroll
// 4.15 fix for empty startScroll option
// 4.16 add resetFollowMouseClasses
// 5.0 Breaking: move setup into init/destroy and convert constructor closures to methods
// 5.1 hide custom scrollbar while on iframe to prevent double scrollbar
// 5.2 fake scroll inertia when leaving iframe
// 5.3 make wheel preventDefault/stopPropagation optional via blockWheel
// 5.3.1 add scrollToAnchor option to smoothScroll, allowing anchor-link scrolling to be disabled and toggled at runtime

import {getPageCoordinates} from './GetCoordinates.js';

export default class AnimateIt {
  blockResizeObserver;
  arWigglers;
  arFollowers;
  scrollDiff;
  scroller;

  #frameFunction;
  #blockSmoothScroll;
  #mouseY;
  #mouseX;
  #mouseSmearY;
  #mouseSmearX;
  #mouseYDiff;
  #mouseXDiff;
  #mouseYPrevDiff;
  #mouseXPrevDiff;
  #mouseCounter;
  #lastScrolledTop;
  #lastScrolledLeft;
  #scrollTop;
  #scrollLeft;
  #scrollTopDiff;
  #scrollLeftDiff;
  #scrollTimeout;
  #windowWidth;
  #windowHeight;
  #prevObserverWidth;
  #prevObserverHeight;
  #maxBodyScrollTop;
  #prevTouchY;
  #onIframe;
  #scrollTopOnIframe;
  #iframeTimeout;
  #enteredFrame;
  #shiftDown;
  #focusSource;
  #touchendScrollDiff;
  #touchMoved;
  #blockedScrollFromWindowBlur;
  #scrollbarEl;
  #scrollbarHeight;
  #scrollDrag;
  #scrollDragPrevY;
  #prevBodyPosition;
  #prevBlockSmoothScroll;
  #isTouch;
  #blFirefox;
  #prevWidth;
  #resizeObserver;
  #animationFrameId;
  #initialized;

  #pauseWiggleFrame;
  #pauseScrollFrame;
  #pauseFollowFrame;

  #boundDoFrame;
  #boundObserverHandler;
  #boundTouchHandler;
  #boundMouseMoveHandler;
  #boundScrollTouchWheel;
  #boundScrollPointerDown;
  #boundResize;
  #boundScrollHandler;
  #boundKeyDownHandler;
  #boundKeyUpHandler;
  #boundKeyPressHandler;
  #boundMouseDownHandler;
  #boundMouseUpHandler;
  #boundFocusHandler;
  #boundDocumentClick;
  #boundBlurWindowHandler;
  #boundFocusWindowHandler;
  #boundLoadHandler;
  #boundHandleIframeEnter;
  #boundHandleIframeMouseOut;
  #boundScrollTouchStart;
  #boundScrollTouchMove;
  #boundScrollTouchEnd;
  #boundHandleMouseOver;
  #boundHandleMouseOut;
  #boundHandleMouseLeave;
  #boundHandleMouseEnterDocument;

  static #MAX_MOUSE_DIFF = 100;
  static #MAX_SCROLL_DIFF = 100;

  constructor({frameFunction = '', pauseWiggle = false, pauseScroll = false, pauseFollow = false} = {}) {
    this.blockResizeObserver = false;
    this.arWigglers = [];
    this.arFollowers = [];
    this.scrollDiff = 0;
    this.scroller = undefined;

    this.#frameFunction = frameFunction;
    this.#blockSmoothScroll = false;
    this.#mouseY = 0;
    this.#mouseX = 0;
    this.#mouseSmearY = 0;
    this.#mouseSmearX = 0;
    this.#mouseYDiff = 0;
    this.#mouseXDiff = 0;
    this.#mouseYPrevDiff = 0;
    this.#mouseXPrevDiff = 0;
    this.#mouseCounter = 0;
    this.#lastScrolledTop = 0;
    this.#lastScrolledLeft = 0;
    this.#scrollTop = 0;
    this.#scrollLeft = 0;
    this.#scrollTopDiff = 0;
    this.#scrollLeftDiff = 0;
    this.#scrollTimeout = undefined;
    this.#windowWidth = document.documentElement.clientWidth;
    this.#windowHeight = document.documentElement.clientHeight;
    this.#prevObserverWidth = 0;
    this.#prevObserverHeight = 0;
    this.#maxBodyScrollTop = 0;
    this.#prevTouchY = 0;
    this.#onIframe = false;
    this.#scrollTopOnIframe = 0;
    this.#iframeTimeout = undefined;
    this.#enteredFrame = false;
    this.#shiftDown = false;
    this.#focusSource = '';
    this.#touchendScrollDiff = 0;
    this.#touchMoved = false;
    this.#blockedScrollFromWindowBlur = false;
    this.#scrollbarEl = undefined;
    this.#scrollbarHeight = 0;
    this.#scrollDrag = false;
    this.#scrollDragPrevY = 0;
    this.#prevBodyPosition = '';
    this.#prevBlockSmoothScroll = false;
    this.#isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    this.#blFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    this.#prevWidth = 0;
    this.#resizeObserver = undefined;
    this.#animationFrameId = undefined;
    this.#initialized = false;

    this.#pauseWiggleFrame = pauseWiggle;
    this.#pauseScrollFrame = pauseScroll;
    this.#pauseFollowFrame = pauseFollow;

    this.#boundDoFrame = this.#doFrame.bind(this);
    this.#boundObserverHandler = this.#observerHandler.bind(this);
    this.#boundTouchHandler = this.#touchHandler.bind(this);
    this.#boundMouseMoveHandler = this.#mousemoveHandler.bind(this);
    this.#boundScrollTouchWheel = this.#scrollTouchWheel.bind(this);
    this.#boundScrollPointerDown = this.#scrollPointerDown.bind(this);
    this.#boundResize = this.#handleWindowResize.bind(this);
    this.#boundScrollHandler = this.#scrollHandler.bind(this);
    this.#boundKeyDownHandler = this.#keyDownHandler.bind(this);
    this.#boundKeyUpHandler = this.#keyUpHandler.bind(this);
    this.#boundKeyPressHandler = this.#keyPressHandler.bind(this);
    this.#boundMouseDownHandler = this.#mousedownHandler.bind(this);
    this.#boundMouseUpHandler = this.#mouseupHandler.bind(this);
    this.#boundFocusHandler = this.#focusHandler.bind(this);
    this.#boundDocumentClick = this.#handleDocumentClick.bind(this);
    this.#boundBlurWindowHandler = this.#blurWindowHandler.bind(this);
    this.#boundFocusWindowHandler = this.#focusWindowHandler.bind(this);
    this.#boundLoadHandler = this.#loadHandler.bind(this);
    this.#boundHandleIframeEnter = this.#handleIframeEnter.bind(this);
    this.#boundHandleIframeMouseOut = this.#handleIframeMouseOut.bind(this);
    this.#boundScrollTouchStart = this.#scrollTouchStart.bind(this);
    this.#boundScrollTouchMove = this.#scrollTouchMove.bind(this);
    this.#boundScrollTouchEnd = this.#scrollTouchEnd.bind(this);
    this.#boundHandleMouseOver = this.#handleMouseOver.bind(this);
    this.#boundHandleMouseOut = this.#handleMouseOut.bind(this);
    this.#boundHandleMouseLeave = this.#handleMouseLeave.bind(this);
    this.#boundHandleMouseEnterDocument = this.#handleMouseEnterDocument.bind(this);
  }

  init = () => {
    if (this.#initialized) return;

    this.#initialized = true;
    this.#boundDoFrame();

    document.documentElement.addEventListener('touchmove', this.#boundTouchHandler);
    document.documentElement.addEventListener('touchstart', this.#boundTouchHandler);
    document.documentElement.addEventListener('mousemove', this.#boundMouseMoveHandler);

    document.documentElement.addEventListener('wheel', this.#boundScrollTouchWheel, {capture: true, passive: false});
    document.documentElement.addEventListener('pointerdown', this.#boundScrollPointerDown);

    window.addEventListener('resize', this.#boundResize);
    document.addEventListener('scroll', this.#boundScrollHandler);

    document.addEventListener('keydown', this.#boundKeyDownHandler);
    document.addEventListener('keyup', this.#boundKeyUpHandler);
    document.addEventListener('keypress', this.#boundKeyPressHandler);

    document.documentElement.addEventListener('mousedown', this.#boundMouseDownHandler);
    document.documentElement.addEventListener('mouseup', this.#boundMouseUpHandler);
    document.documentElement.addEventListener('focus', this.#boundFocusHandler, true);

    document.addEventListener('click', this.#boundDocumentClick);

    window.addEventListener('blur', this.#boundBlurWindowHandler);
    window.addEventListener('focus', this.#boundFocusWindowHandler);
    window.addEventListener('load', this.#boundLoadHandler);

    document.body.addEventListener('mouseover', this.#boundHandleMouseOver, true);
    document.body.addEventListener('mouseout', this.#boundHandleMouseOut, true);
    document.addEventListener('mouseleave', this.#boundHandleMouseLeave);
    document.addEventListener('mouseenter', this.#boundHandleMouseEnterDocument);

    const bodyElement = document.querySelector('body');
    if (bodyElement) {
      this.#resizeObserver = new ResizeObserver(this.#boundObserverHandler);
      this.#resizeObserver.observe(bodyElement);
    }

    this.resizeHandler();
    this.#scrollHandler();
  }

  destroy = () => {
    if (!this.#initialized) return;

    this.removeSmoothScroll();

    document.documentElement.removeEventListener('touchmove', this.#boundTouchHandler);
    document.documentElement.removeEventListener('touchstart', this.#boundTouchHandler);
    document.documentElement.removeEventListener('mousemove', this.#boundMouseMoveHandler);

    document.documentElement.removeEventListener('wheel', this.#boundScrollTouchWheel, {capture: true});
    document.documentElement.removeEventListener('pointerdown', this.#boundScrollPointerDown);

    window.removeEventListener('resize', this.#boundResize);
    document.removeEventListener('scroll', this.#boundScrollHandler);

    document.removeEventListener('keydown', this.#boundKeyDownHandler);
    document.removeEventListener('keyup', this.#boundKeyUpHandler);
    document.removeEventListener('keypress', this.#boundKeyPressHandler);

    document.documentElement.removeEventListener('mousedown', this.#boundMouseDownHandler);
    document.documentElement.removeEventListener('mouseup', this.#boundMouseUpHandler);
    document.documentElement.removeEventListener('focus', this.#boundFocusHandler, true);

    document.removeEventListener('click', this.#boundDocumentClick);

    window.removeEventListener('blur', this.#boundBlurWindowHandler);
    window.removeEventListener('focus', this.#boundFocusWindowHandler);
    window.removeEventListener('load', this.#boundLoadHandler);

    document.body.removeEventListener('mouseover', this.#boundHandleMouseOver, true);
    document.body.removeEventListener('mouseout', this.#boundHandleMouseOut, true);
    document.removeEventListener('mouseleave', this.#boundHandleMouseLeave);
    document.removeEventListener('mouseenter', this.#boundHandleMouseEnterDocument);

    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
      this.#resizeObserver = undefined;
    }

    if (typeof this.#animationFrameId !== 'undefined') {
      cancelAnimationFrame(this.#animationFrameId);
      this.#animationFrameId = undefined;
    }

    clearTimeout(this.#scrollTimeout);
    clearTimeout(this.#iframeTimeout);
    this.#scrollTimeout = undefined;
    this.#iframeTimeout = undefined;

    document.body.classList.remove('body--follow-mouse');
    this.#initialized = false;
  }

  smoothScroll = ({
    speed = 0.1,
    bounce = 0.01,
    iframeScrollDelay = 1000,
    blockWheel = false,
    useHorizontalWheel = false,
    startScroll = -1,
    scrollToAnchor = true,
  } = {}) => {
    this.removeSmoothScroll();

    if (this.#isTouch) {
      document.documentElement.addEventListener('touchstart', this.#boundScrollTouchStart);
      document.documentElement.addEventListener('touchmove', this.#boundScrollTouchMove);
      document.documentElement.addEventListener('touchend', this.#boundScrollTouchEnd);

      document.body.style.touchAction = 'none';
    } else {
      document.body.classList.add('body--animate-it-smoothscroll');
      document.body.classList.add('body--animate-it-smoothscroll-initialized');

      this.#scrollbarEl = document.createElement('button');
      this.#scrollbarEl.classList.add('animate-it-scrollbar');
      this.#scrollbarEl.setAttribute('aria-label', 'Scrollbar');
      document.body.appendChild(this.#scrollbarEl);

      document.body.addEventListener('mouseenter', this.#boundHandleIframeEnter, true);
      document.body.addEventListener('mouseout', this.#boundHandleIframeMouseOut);
    }

    const smoothScroll = {
      tempY: this.#scrollTop,
      targetY: this.#scrollTop,
      elY: this.#scrollTop,
      speed,
      bounce,
      iframeScrollDelay,
      blockWheel,
      useHorizontalWheel,
      scrollToAnchor,
    };

    this.scroller = smoothScroll;
    this.resizeHandler(true);

    setTimeout(() => {
      if (startScroll == -1 || startScroll == '' || typeof startScroll == 'undefined' || startScroll === null) {
        this.setScrollPosHard({pos: this.#scrollTop});
      } else {
        this.setScrollPosHard({pos: startScroll});
      }
    }, 100);

    return smoothScroll;
  }

  leaveIframe = () => {
    this.#enteredFrame = false;
    clearTimeout(this.#iframeTimeout);

    if (this.#onIframe) {
      const scrollDiff = (this.#scrollTop - this.#scrollTopOnIframe) * 10;

      this.setScrollPosHard({pos: this.#scrollTop});

      // because inertia from regular scroll is lost, and deltaY returns 0
      // add a fake inertia when leaving the iframe
      if (scrollDiff !== 0)  this.setScrollPosSoft({pos: this.#scrollTop + scrollDiff});

      this.#onIframe = false;
      document.body.classList.add('body--animate-it-smoothscroll');
    }

    if (typeof this.scroller !== 'object') return;

    if (this.#blockedScrollFromWindowBlur) {
      document.body.classList.add('body--animate-it-smoothscroll');
      this.enableSmoothScroll();
      this.#blockedScrollFromWindowBlur = false;
    }
  }

  disableSmoothScroll = () => {
    this.#blockSmoothScroll = true;
    if (this.#scrollbarEl) this.#scrollbarEl.disabled = true;
  }

  enableSmoothScroll = () => {
    this.#blockSmoothScroll = false;
    if (this.#scrollbarEl) this.#scrollbarEl.disabled = false;
  }

  removeSmoothScroll = () => {
    document.body.classList.remove('body--animate-it-smoothscroll');
    document.body.classList.remove('body--animate-it-smoothscroll-initialized');
    document.body.removeEventListener('mouseenter', this.#boundHandleIframeEnter, true);
    document.body.removeEventListener('mouseout', this.#boundHandleIframeMouseOut);

    document.documentElement.removeEventListener('touchstart', this.#boundScrollTouchStart);
    document.documentElement.removeEventListener('touchmove', this.#boundScrollTouchMove);
    document.documentElement.removeEventListener('touchend', this.#boundScrollTouchEnd);

    document.body.style.touchAction = '';

    if (this.#scrollbarEl) {
      this.#scrollbarEl.remove();
      this.#scrollbarEl = undefined;
    }

    this.#blockSmoothScroll = false;
    this.#blockedScrollFromWindowBlur = false;
    this.#onIframe = false;
    this.#enteredFrame = false;
    this.scroller = undefined;
  }

  setScrollPosHard = ({pos = 0}) => {
    if (typeof this.scroller == 'object') {
      this.scroller.tempY = pos;
      this.scroller.targetY = pos;
      this.scroller.elY = pos;
    }

    window.scroll({top: pos});
    this.#setScrollerMax();
  }

  setScrollPosSoft = ({pos = 0}) => {
    if (typeof this.scroller == 'object') this.scroller.targetY = pos;
    this.#setScrollerMax();
  }

  wiggle = ({
    selector,
    speed = 0.1,
    bounce = 0.01,
    distance = 20,
    switchPerSec = 2,
    slowScroll = false,
    mousePush = false,
    mousePushRate = 1,
    scrollPush = false,
    scrollPushRate = 1,
    wiggle = true,
  } = {}) => {
    let element;
    if (selector instanceof Element) {
      element = selector;
    } else {
      element = document.querySelector(selector);
      if (!element) return;
    }

    element.classList.add('animate-it-wiggler');

    this.#scrollHandler();

    const parentEl = element.parentElement;
    if (slowScroll && parentEl && (parentEl.classList.contains('fader') || parentEl.classList.contains('fader2'))) {
      parentEl.classList.add('fader--still');
    }

    const wiggler = {
      element,
      startY: 0,
      tempY: slowScroll ? -this.#scrollTop : 0,
      targetY: 0,
      elY: slowScroll ? -this.#scrollTop : 0,
      prevElY: slowScroll ? -this.#scrollTop : 0,
      diffY: 0,
      startX: 0,
      tempX: this.#scrollLeft,
      targetX: 0,
      elX: this.#scrollLeft,
      prevElX: this.#scrollLeft,
      diffX: 0,
      speed,
      bounce,
      distance,
      switchEvery: 60 / switchPerSec,
      switchCounter: 0,
      slowScroll,
      mousePush,
      mousePushRate,
      scrollPush,
      scrollPushRate,
      wiggle,
    };

    this.arWigglers.push(wiggler);
    this.resizeHandler(true);

    return wiggler;
  }

  destroyWiggler = (wiggler, removeElement = false) => {
    const index = this.arWigglers.indexOf(wiggler);
    if (index > -1) {
      this.arWigglers.splice(index, 1);
      if (removeElement) wiggler.element.remove();
    }
  }

  followMouse = ({
    selector,
    speed = 1,
    bounce = 0.1,
    rotate = false,
    scrollSmear = false,
  } = {}) => {
    let element;
    if (selector instanceof Element) {
      element = selector;
    } else {
      element = document.querySelector(selector);
      if (!element) return;
    }

    const dot = document.createElement('div');
    dot.classList.add('animate-it-mouse__dot');
    element.appendChild(dot);

    for (let i = 0; i < 4; i++) {
      const corner = document.createElement('div');
      corner.classList.add('animate-it-mouse__corner');
      corner.classList.add('animate-it-mouse__corner--' + i);
      element.appendChild(corner);
    }

    element.classList.add('animate-it-mouse');
    if (scrollSmear) element.classList.add('animate-it-mouse--smear');

    document.body.classList.add('body--follow-mouse');

    this.#mouseSmearY = (this.#windowHeight / 2) + 100;
    this.#mouseSmearX = this.#windowWidth / 2;
    this.#mouseY = this.#mouseSmearY;
    this.#mouseX = this.#mouseSmearX;
    const startY = this.#mouseY + this.#scrollTop;
    const startX = this.#mouseX + this.#scrollLeft;

    const follower = {
      element,
      tempY: startY,
      targetY: startY,
      elY: startY,
      tempX: startX,
      targetX: startX,
      elX: startX,
      speed,
      bounce,
      rotate,
      scrollSmear,
    };

    this.arFollowers.push(follower);

    return follower;
  }

  resetFollowMouseClasses = () => {
    for (let i = 0; i < this.arFollowers.length; i++) {
      const element = this.arFollowers[i].element;
      element.classList.remove('mousy--prev');
      element.classList.remove('mousy--next');
      element.classList.remove('animate-it-mouse--hidden');
      element.classList.remove('animate-it-mouse--inverted');
      element.classList.remove('animate-it-mouse--drag');
      element.classList.remove('animate-it-mouse--drag-hor');
      element.classList.remove('animate-it-mouse--dragging');
      element.classList.remove('animate-it-mouse--dragging-hor');
    }

    this.leaveIframe();
  }

  resizeHandler = (force) => {
    this.#windowWidth = document.documentElement.clientWidth;
    this.#windowHeight = document.documentElement.clientHeight;

    const windowInnerHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    if (getComputedStyle(document.body).position !== 'fixed') {
      this.#maxBodyScrollTop = documentHeight - windowInnerHeight;
    }

    if (this.#windowWidth == this.#prevWidth && force != true) return;

    this.#prevWidth = this.#windowWidth;

    for (let i = 0; i < this.arWigglers.length; i++) {
      if (this.arWigglers[i].slowScroll) {
        const el = this.arWigglers[i].element;
        el.classList.remove('animate-it-wiggler--slowscroll');

        el.style.top = '';
        el.style.left = '';
        el.style.width = '';
        el.style.transform = '';

        const coords = getPageCoordinates(el);
        const rect = el.getBoundingClientRect();

        el.style.top = coords.top + 'px';
        el.style.left = coords.left + 'px';
        el.style.width = rect.width + 'px';

        el.classList.add('animate-it-wiggler--slowscroll');
      }
    }

    this.#scrollHandler();
    this.#wiggleFrameHandler();
  }

  #doFrame() {
    const bodyElement = document.querySelector('body');
    if (bodyElement) {
      const bodyPosition = window.getComputedStyle(bodyElement).position;
      if (bodyPosition != this.#prevBodyPosition) this.#fixReset();
      this.#prevBodyPosition = bodyPosition;
    }

    if (!this.#pauseWiggleFrame) this.#wiggleFrameHandler();
    if (!this.#pauseScrollFrame) this.#scrollFrameHandler();
    if (!this.#pauseFollowFrame) this.#followFrameHandler();

    if (typeof this.#frameFunction == 'function') this.#frameFunction();

    this.#animationFrameId = requestAnimationFrame(this.#boundDoFrame);
  }

  // Public methods to pause/resume frame handlers
  pauseWiggle = () => { this.#pauseWiggleFrame = true; }
  resumeWiggle = () => { this.#pauseWiggleFrame = false; }

  pauseScroll = () => { this.#pauseScrollFrame = true; }
  resumeScroll = () => { this.#pauseScrollFrame = false; }

  pauseFollow = () => { this.#pauseFollowFrame = true; }
  resumeFollow = () => { this.#pauseFollowFrame = false; }

  // Set multiple handlers paused state at once. Pass `null` to skip.
  setFrameHandlersPaused = ({wiggle = null, scroll = null, follow = null} = {}) => {
    if (wiggle !== null) this.#pauseWiggleFrame = !!wiggle;
    if (scroll !== null) this.#pauseScrollFrame = !!scroll;
    if (follow !== null) this.#pauseFollowFrame = !!follow;
  }

  #handleIframeEnter(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (!this.#enteredFrame && typeof this.scroller !== 'undefined' && target.matches('iframe')) {
      clearTimeout(this.#iframeTimeout);
      this.#enteredFrame = true;

      this.#iframeTimeout = setTimeout(() => {
        this.#onIframe = true;
        document.body.classList.remove('body--animate-it-smoothscroll');
        if (this.#scrollbarEl) this.#scrollbarEl.classList.remove('animate-it-scrollbar--visible');
      }, this.scroller.iframeScrollDelay);
    }
  }

  #handleIframeMouseOut(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.matches('iframe')) this.leaveIframe();
  }

  #scrollFrameHandler() {
    if (typeof this.scroller == 'undefined' || this.#onIframe) return;

    if (this.#scrollbarEl) {
      this.#scrollbarHeight = (this.#windowHeight / document.documentElement.scrollHeight) * this.#windowHeight;
      const scrollbarTop = (this.#scrollTop / this.#maxBodyScrollTop) * (this.#windowHeight - this.#scrollbarHeight);
      this.#scrollbarEl.style.transform = 'translateY(' + scrollbarTop + 'px)';

      if (this.#maxBodyScrollTop == 0) {
        this.#scrollbarEl.classList.remove('animate-it-scrollbar--visible');
      } else {
        this.#scrollbarEl.classList.add('animate-it-scrollbar--visible');
        this.#scrollbarEl.style.height = this.#scrollbarHeight + 'px';
      }
    }

    if (this.#blockSmoothScroll) {
      this.#prevBlockSmoothScroll = this.#blockSmoothScroll;
      return;
    }

    if (this.#prevBlockSmoothScroll != this.#blockSmoothScroll && !this.#blockSmoothScroll) {
      this.resizeHandler();
      this.scroller.tempY = this.#scrollTop;
      this.scroller.targetY = this.#scrollTop;
      this.scroller.elY = this.#scrollTop;
    }

    this.#prevBlockSmoothScroll = this.#blockSmoothScroll;

    const distY = (this.scroller.targetY - this.scroller.elY) * this.scroller.speed;
    this.scroller.tempY += distY;

    if (this.scroller.tempY < 0) this.scroller.tempY = 0;
    if (this.scroller.tempY > this.#maxBodyScrollTop) this.scroller.tempY = this.#maxBodyScrollTop;

    if (Math.abs(distY) < 0.01) return;

    this.scroller.elY += this.scroller.bounce * (this.scroller.tempY + distY - this.scroller.elY);

    window.scroll({top: this.scroller.elY});
  }

  #wiggleFrameHandler() {
    if (this.#mouseYPrevDiff == this.#mouseYDiff && this.#mouseXPrevDiff == this.#mouseXDiff) {
      this.#mouseCounter++;
    } else {
      this.#mouseCounter = 0;
    }

    if (this.#mouseCounter > 10) {
      this.#mouseYDiff = 0;
      this.#mouseXDiff = 0;
    }

    this.#mouseYPrevDiff = this.#mouseYDiff;
    this.#mouseXPrevDiff = this.#mouseXDiff;

    for (let i = 0; i < this.arWigglers.length; i++) {
      let item = this.arWigglers[i];

      if (item.wiggle) {
        item.switchCounter++;
        if (item.switchCounter > item.switchEvery) {
          item.switchCounter = 0;

          item.targetY = (Math.random() * item.distance) - (item.distance / 2);
          item.targetX = (Math.random() * item.distance) - (item.distance / 2);
        }
      }

      let scopeY;
      let scopeX;
      if (item.slowScroll) {
        scopeY = item.targetY - this.#scrollTop;
        scopeX = item.targetX - this.#scrollLeft;
      } else {
        scopeY = item.targetY;
        scopeX = item.targetX;
      }

      if (item.mousePush) {
        let mousePushAmount = item.mousePushRate;
        mousePushAmount /= Math.sqrt(item.speed);

        scopeX += this.#mouseXDiff * mousePushAmount;
        scopeY += this.#mouseYDiff * mousePushAmount;
      }

      if (item.scrollPush) {
        let scrollPushAmount = item.scrollPushRate;
        scrollPushAmount /= Math.sqrt(item.speed);

        scopeX += this.#scrollLeftDiff * scrollPushAmount;
        scopeY += this.#scrollTopDiff * scrollPushAmount;
      }

      const distY = (scopeY - item.elY) * item.speed;
      item.tempY += distY;
      item.elY += item.bounce * (item.tempY + distY - item.elY);

      const distX = (scopeX - item.elX) * item.speed;
      item.tempX += distX;
      item.elX += item.bounce * (item.tempX + distX - item.elX);

      const transform3d = item.elX + 'px, ' + item.elY + 'px, 0';
      if (this.#blFirefox) {
        item.element.style.transform = 'translate3d(' + transform3d + ') rotate(0.02deg)';
      } else {
        item.element.style.transform = 'translate3d(' + transform3d + ')';
      }

      item.diffX = item.elX - item.prevElX;
      item.diffY = item.elY - item.prevElY;

      item.prevElX = item.elX;
      item.prevElY = item.elY;

      this.arWigglers[i] = item;
    }
  }

  #followFrameHandler() {
    for (let i = 0; i < this.arFollowers.length; i++) {
      let item = this.arFollowers[i];

      const startY = item.elY;
      const startX = item.elX;

      let scopeMouseX;
      let scopeMouseY;

      if (item.scrollSmear && !this.#isTouch) {
        scopeMouseX = this.#mouseSmearX;
        scopeMouseY = this.#mouseSmearY;
      } else {
        scopeMouseX = this.#mouseX;
        scopeMouseY = this.#mouseY;
      }

      item.targetY = scopeMouseY;
      item.targetX = scopeMouseX;

      const distY = (item.targetY - item.elY) * item.speed;
      item.tempY += distY;
      item.elY += item.bounce * (item.tempY + distY - item.elY);

      const distX = (item.targetX - item.elX) * item.speed;
      item.tempX += distX;
      item.elX += item.bounce * (item.tempX + distX - item.elX);

      let transform3d;
      let distance;
      if (item.rotate) {
        let rotation = (Math.atan2(item.elY - startY, item.elX - startX) * 180) / Math.PI;
        distance = Math.sqrt(Math.abs(item.elY - startY) + Math.abs(item.elX - startX));

        distance -= 2;
        if (distance < 0) {
          distance = 0;
          rotation = 0;
        }

        transform3d = item.elX + 'px, ' + item.elY + 'px, 0) rotate(' + rotation + 'deg';
        item.element.style.transform = 'translate3d(' + transform3d + ')';
      } else {
        distance = 0;
        transform3d = item.elX + 'px, ' + item.elY + 'px, 0';
        item.element.style.transform = 'translate3d(' + transform3d + ')';
      }

      const dot = item.element.querySelector('.animate-it-mouse__dot');
      if (dot) dot.style.transform = 'scale(' + (distance + 1) + ', 1)';

      this.arFollowers[i] = item;
    }
  }

  #mousedownHandler(event) {
    this.#focusSource = 'mouse';

    const target = event.target;
    if (!(target instanceof Element)) return;

    const el = target.closest('.animate-it-scrollbar');
    if (el && !this.#isTouch) {
      this.#scrollDrag = true;
      this.#scrollDragPrevY = event.clientY;
      el.classList.add('animate-it-scrollbar--drag');
    }
  }

  #mousemoveHandler(event) {
    if (!this.#isTouch) {
      this.#mouseSmearX = event.pageX;
      this.#mouseSmearY = event.pageY;

      this.#inputPositionChange(event.clientX, event.clientY);

      if (this.#scrollDrag && typeof this.scroller === 'object') {
        const diff = event.clientY - this.#scrollDragPrevY;
        const targetDiff = diff * (this.#maxBodyScrollTop / (this.#windowHeight - this.#scrollbarHeight));

        this.scroller.targetY += targetDiff;
        this.#setScrollerMax();

        this.#scrollDragPrevY = event.clientY;
      }
    }
  }

  #mouseupHandler() {
    this.#scrollDrag = false;
    if (this.#scrollbarEl) this.#scrollbarEl.classList.remove('animate-it-scrollbar--drag');
  }

  #touchHandler(event) {
    const evt = (typeof event.originalEvent === 'undefined') ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    if (!touch) return;

    this.#inputPositionChange(touch.pageX, touch.pageY);
  }

  #inputPositionChange(x, y) {
    const tempX = this.#mouseX;
    const tempY = this.#mouseY;

    this.#mouseX = x;
    this.#mouseY = y;

    this.#mouseXDiff = this.#mouseX - tempX;
    this.#mouseYDiff = this.#mouseY - tempY;

    this.#limitMouseDiff();
  }

  #limitMouseDiff() {
    let multiplier;
    if (this.#mouseXDiff > AnimateIt.#MAX_MOUSE_DIFF) {
      multiplier = AnimateIt.#MAX_MOUSE_DIFF / this.#mouseXDiff;
      this.#mouseXDiff = AnimateIt.#MAX_MOUSE_DIFF;
      this.#mouseYDiff *= multiplier;
    }

    if (this.#mouseYDiff > AnimateIt.#MAX_MOUSE_DIFF) {
      multiplier = AnimateIt.#MAX_MOUSE_DIFF / this.#mouseYDiff;
      this.#mouseYDiff = AnimateIt.#MAX_MOUSE_DIFF;
      this.#mouseXDiff *= multiplier;
    }

    if (this.#mouseXDiff < -AnimateIt.#MAX_MOUSE_DIFF) {
      multiplier = Math.abs(AnimateIt.#MAX_MOUSE_DIFF / this.#mouseXDiff);
      this.#mouseXDiff = -AnimateIt.#MAX_MOUSE_DIFF;
      this.#mouseYDiff *= multiplier;
    }

    if (this.#mouseYDiff < -AnimateIt.#MAX_MOUSE_DIFF) {
      multiplier = Math.abs(AnimateIt.#MAX_MOUSE_DIFF / this.#mouseYDiff);
      this.#mouseYDiff = -AnimateIt.#MAX_MOUSE_DIFF;
      this.#mouseXDiff *= multiplier;
    }
  }

  #scrollTouchStart(event) {
    const evt = (typeof event.originalEvent === 'undefined') ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    if (!touch) return;

    this.#prevTouchY = touch.pageY;
    this.#touchMoved = false;
  }

  #scrollTouchMove(event) {
    event.preventDefault();

    this.#touchMoved = true;

    const evt = (typeof event.originalEvent === 'undefined') ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    if (!touch) return;
    const touchY = touch.pageY;

    this.scrollDiff = this.#prevTouchY - touchY;
    this.#touchendScrollDiff = this.scrollDiff;

    this.#prevTouchY = touchY;

    if (typeof this.scroller === 'object') this.scroller.targetY += this.scrollDiff;

    this.#setScrollerMax();
  }

  #scrollTouchEnd() {
    if (!this.#touchMoved) return;
    this.scrollDiff = 10 * this.#touchendScrollDiff;

    if (typeof this.scroller === 'object') this.scroller.targetY += this.scrollDiff;
    this.#setScrollerMax();
  }

  #scrollTouchWheel(event) {
    const target = event.target;
    if (target instanceof Element && target.matches('iframe')) return;

    const horizontalScroll = (typeof this.scroller === 'object' && this.scroller.useHorizontalWheel)
      ? event.deltaX
      : 0;
    this.scrollDiff = event.deltaY + horizontalScroll;
    // console.log(this.scrollDiff);

    if (typeof this.scroller === 'object' && !this.#blockSmoothScroll) {
      // Only block native scroll / stop propagation when `blockWheel` is set
      // on the scroller (opt-in). Default behaviour is to allow other wheel
      // listeners and native scrolling.
      if (this.scroller.blockWheel) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.scroller.targetY += this.scrollDiff;
    }

    this.#setScrollerMax();
  }

  #scrollPointerDown(event) {
    if (typeof this.scroller !== 'object') return;
    if (event.pointerType == 'pen' && !this.#isTouch) this.removeSmoothScroll();
  }

  #setScrollerMax() {
    requestAnimationFrame(() => {
      this.scrollDiff = 0;
    });

    if (typeof this.scroller !== 'object') return;

    if (this.scroller.targetY < 0) this.scroller.targetY = 0;
    if (this.scroller.targetY > this.#maxBodyScrollTop) this.scroller.targetY = this.#maxBodyScrollTop;
  }

  #handleWindowResize() {
    requestAnimationFrame(() => {
      this.resizeHandler();
    });
  }

  #scrollHandler() {
    this.#scrollTopOnIframe = this.#scrollTop;
    this.#scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.#scrollLeft = window.scrollX || document.documentElement.scrollLeft;

    this.#scrollLeftDiff = this.#lastScrolledLeft - this.#scrollLeft;
    this.#scrollTopDiff = this.#lastScrolledTop - this.#scrollTop;

    if (this.#scrollLeftDiff > AnimateIt.#MAX_SCROLL_DIFF) this.#scrollLeftDiff = AnimateIt.#MAX_SCROLL_DIFF;
    if (this.#scrollLeftDiff < -AnimateIt.#MAX_SCROLL_DIFF) this.#scrollLeftDiff = -AnimateIt.#MAX_SCROLL_DIFF;

    if (this.#scrollTopDiff > AnimateIt.#MAX_SCROLL_DIFF) this.#scrollTopDiff = AnimateIt.#MAX_SCROLL_DIFF;
    if (this.#scrollTopDiff < -AnimateIt.#MAX_SCROLL_DIFF) this.#scrollTopDiff = -AnimateIt.#MAX_SCROLL_DIFF;

    this.#lastScrolledLeft = this.#scrollLeft;
    this.#lastScrolledTop = this.#scrollTop;

    if (!this.#isTouch) {
      if (this.#lastScrolledLeft !== this.#scrollLeft) {
        this.#mouseSmearX -= this.#lastScrolledLeft;
        this.#lastScrolledLeft = this.#scrollLeft;
        this.#mouseSmearX += this.#lastScrolledLeft;
      }

      if (this.#lastScrolledTop !== this.#scrollTop) {
        this.#mouseSmearY -= this.#lastScrolledTop;
        this.#lastScrolledTop = this.#scrollTop;
        this.#mouseSmearY += this.#lastScrolledTop;
      }
    }

    clearTimeout(this.#scrollTimeout);
    this.#scrollTimeout = setTimeout(() => {
      this.#scrollLeftDiff = 0;
      this.#scrollTopDiff = 0;
    }, 100);
  }

  #formElementFocused(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return false;
    return target.tagName == 'INPUT' || target.tagName == 'TEXTAREA' || target.tagName == 'SELECT' || target.isContentEditable;
  }

  #keyPressHandler(event) {
    if (typeof this.scroller !== 'object' || this.#formElementFocused(event)) return;

    if (event.code === 'Space') {
      this.scrollDiff = this.#shiftDown ? -this.#windowHeight : this.#windowHeight;
      this.scroller.targetY += this.scrollDiff;
    }

    this.#setScrollerMax();
  }

  #keyDownHandler(event) {
    this.#focusSource = 'keyboard';

    if (typeof this.scroller !== 'object' || this.#formElementFocused(event)) return;

    if (event.key === 'ArrowUp') {
      this.scrollDiff = -100;
    } else if (event.key === 'ArrowDown') {
      this.scrollDiff = 100;
    } else if (event.key === 'PageUp') {
      this.scrollDiff = -this.#windowHeight;
    } else if (event.key === 'PageDown') {
      this.scrollDiff = this.#windowHeight;
    } else if (event.key === 'Home') {
      this.scrollDiff = 0;
      this.scroller.targetY = 0;
      this.#setScrollerMax();
      return;
    } else if (event.key === 'End') {
      this.scrollDiff = 0;
      this.scroller.targetY = this.#maxBodyScrollTop;
      this.#setScrollerMax();
      return;
    } else if (event.key === 'Shift') {
      this.#shiftDown = true;
    }

    this.scroller.targetY += this.scrollDiff;

    this.#setScrollerMax();
  }

  #keyUpHandler(event) {
    if (event.key === 'Shift') this.#shiftDown = false;
  }

  #focusHandler(event) {
    if (
      typeof this.scroller !== 'object'
      || this.#focusSource == 'mouse'
      || event.target != document.activeElement
    ) return;

    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    requestAnimationFrame(() => {
      const rect = target.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > this.#windowHeight) this.#scrollToElement(target);
    });
  }

  #handleDocumentClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const linkEl = target.closest('a');
    if (linkEl) this.#linkHandler(event, linkEl);
  }

  #linkHandler(event, linkEl) {
    if (typeof this.scroller !== 'object' || this.scroller.scrollToAnchor === false) return;

    const href = linkEl.getAttribute('href');
    if (!href) return;

    let hrefResolved;
    try {
      hrefResolved = new URL(href, window.location.href).href;
    } catch (error) {
      return;
    }

    const hrefNoHash = hrefResolved.split('#')[0];
    const currentNoHash = window.location.href.split('#')[0];

    if ((hrefNoHash === currentNoHash || href.startsWith('#')) && href.indexOf('#') !== -1) {
      event.preventDefault();
      const hrefHash = href.split('#')[1];
      this.#scrollToElement(document.getElementById(hrefHash));
    }
  }

  #scrollToElement(el) {
    if (!el) return;

    const offsetTop = getPageCoordinates(el).top;
    const center = offsetTop - (this.#windowHeight / 2);
    this.setScrollPosSoft({pos: center});
  }

  #blurWindowHandler() {
    if (typeof this.scroller !== 'object') return;

    if (this.#blockSmoothScroll == false) {
      this.#blockedScrollFromWindowBlur = true;
      this.disableSmoothScroll();
      document.body.classList.remove('body--animate-it-smoothscroll');
    }
  }

  #focusWindowHandler() {
    if (typeof this.scroller !== 'object') return;

    if (this.#blockedScrollFromWindowBlur) {
      document.body.classList.add('body--animate-it-smoothscroll');
      this.enableSmoothScroll();
      this.#blockedScrollFromWindowBlur = false;
    }
  }

  #fixReset() {
    this.#scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.#scrollLeft = window.scrollX || document.documentElement.scrollLeft;

    let i;
    for (i = 0; i < this.arWigglers.length; i++) {
      if (this.arWigglers[i].slowScroll) {
        this.arWigglers[i].startY = 0;
        this.arWigglers[i].tempY = -this.#scrollTop;
        this.arWigglers[i].targetY = 0;
        this.arWigglers[i].elY = -this.#scrollTop;
        this.arWigglers[i].startX = 0;
        this.arWigglers[i].tempX = this.#scrollLeft;
        this.arWigglers[i].targetX = 0;
        this.arWigglers[i].elX = this.#scrollLeft;
      }
    }

    for (i = 0; i < this.arFollowers.length; i++) {
      let startY;
      if (this.arFollowers[i].scrollSmear && !this.#isTouch) {
        startY = this.#mouseY + this.#scrollTop;
      } else {
        startY = this.#mouseY;
      }

      const startX = this.#mouseX + this.#scrollLeft;

      this.arFollowers[i].tempY = startY;
      this.arFollowers[i].targetY = startY;
      this.arFollowers[i].elY = startY;
      this.arFollowers[i].tempX = startX;
      this.arFollowers[i].targetX = startX;
      this.arFollowers[i].elX = startX;
    }
  }

  #observerResize() {
    if (
      (this.#windowWidth != this.#prevObserverWidth || this.#windowHeight != this.#prevObserverHeight)
      && this.#prevObserverWidth != 0
    ) {
      this.#prevObserverWidth = this.#windowWidth;
      this.#prevObserverHeight = this.#windowHeight;
      return;
    }

    this.#prevObserverWidth = this.#windowWidth;
    this.#prevObserverHeight = this.#windowHeight;
    this.resizeHandler(true);
  }

  #observerHandler() {
    if (!this.blockResizeObserver) requestAnimationFrame(() => this.#observerResize());
  }

  #loadHandler() {
    this.resizeHandler(true);
  }

  #handleMouseOver(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const interactiveEls = 'button, a, input, label, textarea, select, *[role="button"], .swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
    const frameEls = 'iframe, input[type="file"]';

    if (target.closest(interactiveEls)) {
      for (let i = 0; i < this.arFollowers.length; i++) {
        this.arFollowers[i].element.classList.add('animate-it-mouse--hover');
      }
    }

    if (target.closest(frameEls)) {
      for (let i = 0; i < this.arFollowers.length; i++) {
        this.arFollowers[i].element.classList.add('animate-it-mouse--hidden');
      }
    }
  }

  #handleMouseOut(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const interactiveEls = 'button, a, input, label, textarea, select, *[role="button"], .swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
    const frameEls = 'iframe, input[type="file"]';

    if (target.closest(interactiveEls)) {
      for (let i = 0; i < this.arFollowers.length; i++) {
        this.arFollowers[i].element.classList.remove('animate-it-mouse--hover');
      }
    }

    if (target.closest(frameEls)) {
      for (let i = 0; i < this.arFollowers.length; i++) {
        this.arFollowers[i].element.classList.remove('animate-it-mouse--hidden');
      }
    }
  }

  #handleMouseLeave(event) {
    const from = event.relatedTarget || event.toElement;
    if (!from || from.nodeName == 'HTML') {
      for (let i = 0; i < this.arFollowers.length; i++) {
        this.arFollowers[i].element.classList.add('animate-it-mouse--hidden');
      }
    }
  }

  #handleMouseEnterDocument() {
    for (let i = 0; i < this.arFollowers.length; i++) {
      this.arFollowers[i].element.classList.remove('animate-it-mouse--hidden');
    }
  }
}
